import api from "@/api/url";

export default {
    namespaced: true,

    state: () => {
        return {
            selectedYear: new Date().getFullYear(),
            meetings: [],
            pageData: {
                currentPage: 1,
                totalPages: 0,
                pageSize: 0,
                total: 0,
            },
            selectedCalendar: {},
            googleCalendarActive: false,
        };
    },

    getters: {
        meetings: state => state.meetings,
        pageData: state => state.pageData,
        selectedYear: state => state.selectedYear,
        currentPageSelection: state => state.currentPageSelection,
        selectedCalendar: state => state.selectedCalendar,
        googleCalendarActive: state => state.googleCalendarActive,
    },

    mutations: {
        set(state, [key, value]) {
            state[key] = value;
        },
    },
    
    actions: {
        setSelectedYear({ commit }, year) {
            commit("set", ["selectedYear", year]);
        },

        // MEETINGS ---------------------------
        fetchMeetings({ commit, state }, params) {
            return api.meeting.getMeetings(params)
                .then((res) => {
                    const data = res.data.data;                    
                    commit("set", ["meetings", data.data]);
                    commit("set", ["pageData", {
                        ...state.pageData,
                        ...data.pageDetails,
                    }]);
                });
        },

        addMeeting({ commit, state }, { external = false, payload }) {
            return api.meeting.addNew(payload)
                .then((resp) => {
                    const data = resp.data.data;

                    if (!external) {    
                        commit("set", ["meetings", [
                            data,
                            ...state.meetings,
                        ]]);
    
                        commit("set", ["pageData", {
                            ...state.pageData,
                            total: state.pageData.total + 1,
                            totalPages:  Math.ceil((state.pageData.total + 1) / state.pageData.pageSize),
                        }]);
                    } else {
                        return data;
                    }
                });
        },

        removeMeeting({ commit, state }, id) {
            return api.meeting.deleteMeeting(id)
                .then((resp) => {
                    const meetings = state.meetings;
                    const updatedMeetings = meetings.filter((meeting) => meeting._id !== id);

                    commit("set", ["meetings", updatedMeetings]);
                    commit("set", ["pageData", {
                        ...state.pageData,
                        total: state.pageData.total - 1,
                        totalPages: Math.ceil((state.pageData.total - 1) / 50),
                    }]);
                });
        },

        duplicateMeeting(_, payload) {
            return api.meeting.duplicate(payload)
                .then((resp) => {});
        },

        fetchOneMeeting(_, id) {
            return api.meeting.getMeeting(id)
                .then((res) => {
                    const data = res.data.data;
                    return data;
                });
        },

        addNote(_, { id, payload }) {
            return api.meeting.addNote(id, payload)
                .then((resp) => {
                    return resp.data.data;
                });
        },

        updateNote(_, { id, payload }) {
            return api.meeting.editNote(id, payload)
                .then((resp) => {
                    return resp.data.data;
                });
        },

        deleteNote(_, { meetingId, noteId }) {
            return api.meeting.deleteNote(meetingId, noteId)
                .then((resp) => {
                    return resp.data.data;
                });
        },
    },
};